import { Component, Inject } from '@angular/core';

@Component({
  selector: 'hospital-booking-footer',
  template: require('./footer.component.html'),
})
export class FooterComponent {
  constructor(
    @Inject('LanguageService') public LanguageService,
    @Inject('$state') public $state,
  ){}

  switchLanguage() {
    this.LanguageService.switchLanguage()
  }

  goToPatientAgreement() {
    window.open(this.$state.href('patient_agreement'))
  }

  goToPrivacyStatement() {
    window.open(this.$state.href('privacy_statement'))
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/hospital-booking/footer/footer.component.ts